import React from 'react';

import get from 'lodash/get';
import { format } from 'date-fns';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Tooltip } from 'flowbite-react';

import User from './User';
import UserRole from './UserRole';
import Badge from './Badge';
import Checkbox from './Checkbox';

const formatter = new Intl.NumberFormat('en', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 2,
});

export default function Cell({ row, col, hidden }) {
  const { type } = col;
  const withLink = col.link && typeof col.link === 'function';
  let content = null;
  let value = get(row, col.key);

  if (col.format) {
    value = col.format(value, row);
  }

  switch (type) {
    case 'component':
      content = <col.component {...col.props(row)} />;
      break;
    case 'user':
      content = <User row={row} />;
      break;
    case 'userRole':
      content = <UserRole row={row} />;
      break;
    case 'date':
      content = value ? format(new Date(value), 'MM/dd/yy') : '';
      break;
    case 'currency':
      content = value ? formatter.format(value) : '';
      break;
    case 'badge':
      content = <Badge value={value} color={col.color(value)} />;
      break;
    case 'checkbox':
      content = (
        <Checkbox col={col} row={row} value={value} readOnly={col.readOnly} />
      );
      break;
    default:
      content = value;
  }

  const valueTooltip =
    col.valueTooltip &&
    typeof col.valueTooltip === 'function' &&
    col.valueTooltip(value, row);

  return (
    <td
      scope="row"
      className={classNames(
        'px-4 py-3 font-normal text-gray-900 dark:text-white',
        {
          'whitespace-nowrap': !col.textWrap,
          'cursor-pointer text-primary-600 underline': col.onClick || withLink,
        }
      )}
      style={{ visibility: hidden ? 'hidden' : 'visible' }}
      onClick={() => {
        col?.onClick?.(value, row);
      }}
    >
      {withLink ? <Link to={col.link(row)}>{content}</Link> : content}{' '}
      {valueTooltip && (
        <div className="inline-flex relative top-1 ml-1">
          <Tooltip content={valueTooltip}>
            <svg
              className="w-5 h-5 text-amber-600"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                fillRule="evenodd"
                d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
                clipRule="evenodd"
              />
            </svg>
          </Tooltip>
        </div>
      )}
    </td>
  );
}
